import { Notification, NotificationStats } from '../types/notifications';

let API_BASE_URL: string;

API_BASE_URL = `${window.location.origin}`;

// Função para obter o token de autenticação
const getAuthToken = (): string | null => {
  return localStorage.getItem('token');
};

// Função para fazer requisições autenticadas
const authenticatedFetch = async (url: string, options: RequestInit = {}): Promise<Response> => {
  const token = getAuthToken();

  const headers = {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
    ...options.headers,
  };

  // Debug para verificar presença de Authorization e evitar 403 do HTTPBearer
  console.debug('[API] authenticatedFetch', {
    url,
    method: options.method || 'GET',
    auth: headers['Authorization'],
  });

  return fetch(url, {
    ...options,
    headers,
  });
};

export const getNotifications = async (
  limit?: number,
  offset?: number,
  unreadOnly?: boolean,
): Promise<Notification[]> => {
  try {
    const params = new URLSearchParams();
    if (limit) params.append('limit', limit.toString());
    if (offset) params.append('offset', offset.toString());
    if (unreadOnly) params.append('unread_only', 'true');

    const response = await authenticatedFetch(`${API_BASE_URL}/api/v2/notifications?${params}`);

    if (!response.ok) {
      console.error(`HTTP error! status: ${response.status}`);
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching notifications:', error);
    // Não usar fallback para dados mockados - deixar o erro ser tratado pelo componente
    throw error;
  }
};

export const getNotificationStats = async (): Promise<NotificationStats> => {
  try {
    const response = await authenticatedFetch(`${API_BASE_URL}/api/v2/notifications/stats`);

    if (!response.ok) {
      console.error(`HTTP error! status: ${response.status}`);
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching notification stats:', error);
    // Não usar fallback para dados mockados - deixar o erro ser tratado pelo componente
    throw error;
  }
};

export const markNotificationAsRead = async (notificationId: string): Promise<void> => {
  try {
    const response = await authenticatedFetch(`${API_BASE_URL}/api/v2/notifications/${notificationId}/read`, {
      method: 'PATCH',
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  } catch (error) {
    console.error('Error marking notification as read:', error);
    throw error;
  }
};

export const markAllNotificationsAsRead = async (): Promise<void> => {
  try {
    const response = await authenticatedFetch(`${API_BASE_URL}/api/v2/notifications/read-all`, {
      method: 'PATCH',
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  } catch (error) {
    console.error('Error marking all notifications as read:', error);
    throw error;
  }
};
